export const amountOptions = [
    'Less than $1,000',
    '$1,000 - $5,000',
    '$5,001 - $50,000',
    '$50,001 - $100,000',
    'More than $100,000',
]
